import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import { 
    ENGAGEMENT_STATUS, 
    FATE_TYPES, 
    SUPPORT_LEVEL, 
    SUPPORT_READY_LEVEL, 
    SUPPORT_TITLE,
    LOCAL_STORAGE_USER_LOGIN_INFO,
} from "@app/constants/Common";
import * as CandidateService from '@app/services/CandidateService';
import {showSuccessMessageSaveData} from "@pages/candidate/Common";
import {toast} from "react-toastify";
import { checkExistsCommonFieldValues } from "@app/utils/CandidateUtils";


const NotesReferSupportCard = ({
    initialNotes,
    candidateId,
    onChange,
    onSave,
    mode = 'Edit', // Default to Edit mode for backward compatibility
    isEditNotes = false,
    allInputInfo
}) => {
    const [isEdit, setIsEdit] = useState(isEditNotes);
    const [notes, setNotes] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});

    useEffect(() => {
        setNotes(initialNotes || {});
    }, [initialNotes]);

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const onChangeInput = (eventOrValues, fieldName) => {
        notes[fieldName] = eventOrValues;
        setNotes({...notes});
        if (onChange) {
            onChange({...notes});
        }
    };

    const updateCandidateNotes = () => {
        // Check xem trong số các trường sử dụng chung, giá trị đã đc nhập bởi user khác cho UV này chưa
        // Nếu có user khác nhập cho UV này giá trị rồi => báo lỗi, ko save thông tin vào DB.
        notes.allCandidateNotesInfo = allInputInfo.allCandidateNotesInfo
        if (checkExistsCommonFieldValues(notes, userLoginInfo.id)) {
            return;
        }
        // setIsLoading(true)
        CandidateService.updateCandidateNotesDetail({candidate_id: candidateId, notes: notes}).then((res) => {
            console.log(JSON.stringify(res))
            showSuccessMessageSaveData(res.sts_code)
            setIsEdit(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            // setIsLoading(false)
        });
    };

    const handleSave = () => {
        if (mode !== 'Search') {
            // In Search mode, automatically call onSave without changing edit state
            setIsEdit(false);
        }

        updateCandidateNotes();
    };

    // Auto-save in Search mode when notes change
    // useEffect(() => {
    //     if (mode === 'Search' && onSave) {
    //         onSave(notes);
    //     }
    // }, [notes, mode, onSave]);

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Notes</h3>
                {mode === 'Edit' && (
                    <div className='card-tools'>
                        {isEdit &&
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => {
                                        setIsEdit(false);
                                    }}
                            >
                                Cancel
                            </button>
                        }
                        {isEdit &&
                            <button type='button'
                                    className='btn btn-primary'
                                    onClick={handleSave}
                            >
                                Save
                            </button>
                        }
                        {!isEdit &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => {
                                        setIsEdit(true);
                                    }}
                            >
                                Edit
                            </button>
                        }
                    </div>
                )}
            </div>
            <div className='card-body row'>
                <div className='input-group col-sm-6 mt-3'>
                    <label className={'w-100'}>Loại duyên nợ</label>
                    <Select options={FATE_TYPES}
                            className={'w-100'}
                            isMulti
                            name={'fate_type'}
                            isDisabled={!isEdit}
                            value={notes.fate_type ? notes.fate_type : ''}
                            onChange={values => onChangeInput(values, 'fate_type')}>
                    </Select>
                    <AllUserInputField arrInfo={notes.allCandidateNotesInfo}
                                       field='fate_type'/>
                </div>
                <div className='input-group col-sm-6 mt-3'>
                    <label className={'w-100'}>Khả năng support</label>
                    <Select options={SUPPORT_LEVEL}
                            className={'w-100'}
                            isMulti
                            name={'support_level'}
                            isDisabled={!isEdit}
                            value={notes.support_level ? notes.support_level : ''}
                            onChange={values => onChangeInput(values, 'support_level')}>
                    </Select>
                    <AllUserInputField arrInfo={notes.allCandidateNotesInfo}
                                       field='support_level'/>
                </div>

                <div className='input-group col-sm-6 mt-3'>
                    <label className={'w-100'}>Mức độ sẵn sàng support</label>
                    <Select options={SUPPORT_READY_LEVEL}
                            className={'w-100'}
                            isMulti
                            name={'support_ready_level'}
                            isDisabled={!isEdit}
                            value={notes.support_ready_level ? notes.support_ready_level : ''}
                            onChange={values => onChangeInput(values, 'support_ready_level')}>
                    </Select>
                    <AllUserInputField arrInfo={notes.allCandidateNotesInfo}
                                       field='support_ready_level'/>
                </div>
                <div className='input-group col-sm-6 mt-3'>
                    <label className={'w-100'}>Danh hiệu support</label>
                    <Select options={SUPPORT_TITLE}
                            className={'w-100'}
                            isMulti
                            name={'support_title'}
                            isDisabled={!isEdit}
                            value={notes.support_title ? notes.support_title : ''}
                            onChange={values => onChangeInput(values, 'support_title')}>
                    </Select>
                    <AllUserInputField arrInfo={notes.allCandidateNotesInfo}
                                       field='support_title'/>
                </div>
                <div className='input-group col-sm-6 mt-3'>
                    <label className={'w-100'}><b>Note (for Nhờ Refer, Hỗ trợ)</b></label>
                    <input type='text' className='form-control'
                           value={notes.note_for_refer_support || ''}
                           disabled={!isEdit}
                           name={'note_for_refer_support'}
                           onChange={e => onChangeInput(e.target.value, e.target.name)}/>
                    <AllUserInputField arrInfo={notes.allCandidateNotesInfo}
                                       field='note_for_refer_support'/>
                </div>
            </div>
        </div>
    );
};

export default NotesReferSupportCard;


